export const createAuthorizationMethod = (authorizationType, choice, choiceTimestamp,hasMessagedClient, messageTimestamp, hasClientCompletedAuthorization, signaturePage, signaturePageUploadTimestamp, hasSubmittedSignaturePageToRac) => {
    return {
        authorizationType,
        choice,
        choiceTimestamp,
        hasMessagedClient,
        messageTimestamp,
        hasClientCompletedAuthorization,
        signaturePage,
        signaturePageUploadTimestamp,
        hasSubmittedSignaturePageToRac
    }
}

export const createDocumentReviewData =  (primaryAuthorizationMethod, spouseAuthorizationMethod, hasReviewedDocuments, hasContactedClient, isReadyToPrepareReturn) => {
    return {
        primary: primaryAuthorizationMethod,
        spouse: spouseAuthorizationMethod,
        hasReviewedDocuments,
        hasContactedClient,
        isReadyToPrepareReturn
    };
}


